module.exports = "/_next/static/images/home-line-b15a780963163fd34bf4bd656cd9cda5.svg";